import { render, staticRenderFns } from "./singleView.vue?vue&type=template&id=15af4c80&"
import script from "./singleView.vue?vue&type=script&lang=js&"
export * from "./singleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports